import React from "react";
import { useI18n } from "@/i18n";
import { useReveal } from "@/hooks/useReveal";
import RevealOnView from "@/components/site/RevealOnView";

export default function Testimonials() {
  const { t } = useI18n();
  const header = useReveal();

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-36 bg-[color:var(--wf-surface)] border-t border-b border-neutral-200"
    >
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div
          ref={header.ref}
          className={`reveal ${header.visible ? "is-visible" : ""} grid grid-cols-1 md:grid-cols-12 gap-8 items-end`}
        >
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 mb-5">
              <span
                className="inline-block w-6 h-px align-middle mr-3"
                style={{ background: "#c9a86a" }}
              />
              {t.testimonials.eyebrow}
            </div>
            <h2
              data-testid="testimonials-title"
              className="font-display text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] tracking-[-0.02em] font-light text-neutral-950"
            >
              {t.testimonials.title}
            </h2>
          </div>
          <div className="md:col-span-5 hidden md:block">
            <div className="relative overflow-hidden rounded-[12px] border border-neutral-200 aspect-[4/3]">
              <img
                src="https://images.pexels.com/photos/29237393/pexels-photo-29237393.jpeg"
                alt="Sposi in un momento condiviso"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {t.testimonials.items.map((it, i) => (
            <RevealOnView
              as="figure"
              key={i}
              delay={i + 1}
              data-testid={`testimonial-card-${i}`}
              className="relative bg-white border border-neutral-200 rounded-[12px] p-8 md:p-10 flex flex-col justify-between min-h-[280px] transition-transform duration-500 hover:-translate-y-1"
            >
              <svg
                aria-hidden
                className="w-8 h-8 text-[color:var(--wf-gold)] mb-6"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M7 7h4v4H8c0 2.2 1.8 4 4 4v3c-4.4 0-8-3.6-8-8V7zm9 0h4v4h-3c0 2.2 1.8 4 4 4v3c-4.4 0-8-3.6-8-8V7z" />
              </svg>
              <blockquote className="font-display text-[20px] md:text-[22px] leading-snug tracking-[-0.01em] text-neutral-900 font-light">
                “{it.quote}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-neutral-200">
                <div className="text-[14px] text-neutral-950 font-medium">
                  {it.author}
                </div>
                <div className="text-[12px] tracking-[0.14em] uppercase text-neutral-500 mt-1">
                  {it.detail}
                </div>
              </figcaption>
            </RevealOnView>
          ))}
        </div>
      </div>
    </section>
  );
}
